/** An Occurrence seat's state: booked, or waiting for the instructor's confirmation. */
export enum SeatStatus {
  Confirmed = "Confirmed",
  Requested = "Requested",
}
